import React, {Component} from 'react';
import {
  getGuestIdData,
  saveApplication,
  startApplication,
  verifyAgentCode,
  verifyAgentCodeV01
} from "../../scripts/sync-manager";
import {AGENT_INFO, APP_SECTION, ENABLE_FLORIDA_FLOW, PRINCIPAL, STORAGE_KEYS} from "../../scripts/constants";
import {isValid, mygaSession} from "../../scripts/myga-session";
import {regex, NassauLog} from "../../scripts/myga-utils";
import {Row, Col} from "react-bootstrap";
import Resources from "../../Resources/Resources";
import MYGAStrings from "../../Resources/Content/MYGAStrings";
import AppContentWrapper from "../../pages/Application/AppContentWrapper/AppContentWrapper";
import {Analytics} from "../../scripts/analytics";
import PopoverTooltip from "../PopoverTooltip";
import {reconcileParties} from "../../scripts/validation";
import {MM_PRODUCT_DTO} from "../../scripts/myga-model";
import GENERATOR from "../../selenium-front-end/generator/Generator";

class GuestEmail extends Component {
  
  constructor(props) {
    super(props);
    // setup default prev/next pages with props overrides
    // this.prevPage = props.prevPage || PAGES.pageDashboard; // 2021.07.14.ADivelbiss - commented in favor of PageManager page stack solution
    // this.nextPage = props.nextPage || PAGES.pageAgentCode; // 2021.07.15.ADivelbiss - commented in favor of PageManager getNextPage solution
  
    // State selector enable
    this.displayStateSelection = ENABLE_FLORIDA_FLOW; // 2022.05.10.ADivelbiss - Need to turn of State Selector for FL temporarily.
    
    // check to see if we have a guest principal saved
    let principal = mygaSession.getPrincipal();
    
    this.state = {
      email: (principal ? principal[PRINCIPAL.email] : ''),
      errorMessage: '',
      agentInfo: mygaSession.getAgentInfo(),
      ackPrivacyPolicy : mygaSession.getMygaSessionValue(STORAGE_KEYS.AckPrivacyPolicy, ''),
      ackTermsOfUse: mygaSession.getMygaSessionValue(STORAGE_KEYS.AckTermsOfUse, ''),
      appStateAbbr: mygaSession.getMygaSessionValue(STORAGE_KEYS.AppStateAbbr),
    };
  }
  
  componentDidMount() {

    // check to see if we have a guest principal saved
    let principal = mygaSession.getPrincipal();

    // this.setState({'principal': principal});
    NassauLog("principal: " + JSON.stringify(principal));

    this.compareToState = this.state
  }

  onNextPressed = async () => {
    await this.startApplication()

    if (process.env.REACT_APP_TESTING === '1' && GENERATOR.getTestModeEnabled()) {
      let actionList = []
      if (this.state.email !== this.compareToState.email) {
        actionList.push({
          type: 'keys',
          id: 'emailId',
          value: this.state.email,
        })
      }
      if (this.state.ackTermsOfUse !== this.compareToState.ackTermsOfUse) {
        actionList.push(
          {
            type: 'click',
            id: 'input-tou-consent',
          }
        )
      }
      if (this.state.ackPrivacyPolicy !== this.compareToState.ackPrivacyPolicy) {
        actionList.push(
          {
            type: 'click',
            id: 'input-pp-consent',
          }
        )
      }
      if (this.state.appStateAbbr === 'FL' && this.state.appStateAbbr !== this.compareToState.appStateAbbr) {
        actionList.push(
          {
            type: 'click',
            id: 'input-state-fl-yes',
          }
        )
      }
      if (this.state.appStateAbbr !== 'FL' && this.state.appStateAbbr !== this.compareToState.appStateAbbr) {
        actionList.push(
          {
            type: 'click',
            id: 'input-state-fl-no',
          }
        )
      }
      await GENERATOR.stageManualActionList(actionList)
    }
  }

  validate = () => {
    // 2021.07.16.ADivelbiss - onNext Validation
    if (!this.pageForm.checkValidity()) {
      this.pageForm.classList.add('was-validated');
      this.setState({
        errorMessage: MYGAStrings.Finances_ErrorMissingInformation
      });
      return false;
    }
    return true;
  };
  
  startApplication = async () => {
    // 2021.07.14.ADivelbiss - Added a check to see if existing principal has the same email.
    // If so then do not request a new principal.
    // 2021.05.11.ADivelbiss - Updated this method to sequentially register the guest email,
    // start the application, and optionally validate the agent referral code at a single
    // point so that the agent referral screen can be completely skipped if a code is present
    // and validated at this point.
    let principal = mygaSession.getPrincipal();
    if (principal===null || principal[PRINCIPAL.email]!==this.state.email) {
      //Clear out existing app to start a new one.
      mygaSession.setCurrentApp(null);
      principal = await getGuestIdData(this.state.email);
    }
    if (isValid(principal)) {
      // 2021.05.21.ADivelbiss - Save the principal to the data layer for GTM
      Analytics.setPrincipalToken(principal[PRINCIPAL.pToken]);
      Analytics.setUsername(principal[PRINCIPAL.userName]);
      Analytics.setSessionId(principal[PRINCIPAL.sessionId]);
      // 2021.07.14.ADivelbiss - Save the state information and PP TOU Ack
      mygaSession.setMygaSessionValue(STORAGE_KEYS.AckPrivacyPolicy,this.state.ackPrivacyPolicy);
      mygaSession.setMygaSessionValue(STORAGE_KEYS.AckTermsOfUse,this.state.ackTermsOfUse);
      mygaSession.setMygaSessionValue(STORAGE_KEYS.AppStateAbbr,this.state.appStateAbbr);
    }
    // If there isn't a current application then start one.
    // NB. there could be a valid application in progress if the user came back to this page
    // to change the "signing state" without changing the email of the principal
    if (mygaSession.getCurrentApp()===null) {
      await startApplication();
    }
    // Handle the case where a referral code was provided in the URL BEFORE we show the agent code page
    if (this.props.agentReferralInfo && this.props.agentReferralInfo[AGENT_INFO.referralCode]) {
      let data = await verifyAgentCode(this.props.agentReferralInfo[AGENT_INFO.referralCode]);
      // let data = await verifyAgentCodeV01(this.props.agentReferralInfo[AGENT_INFO.referralCode]);
      if (data.referral!==null) {
        // We have a valid agent code at this point so save it
        // and skip to the process overview page instead of
        // showing the agent info page.
        // 2021.06.15.ADivelbiss - Get the agent info from the API then set the recommendation code
        let agentInfo = data.referral;
        agentInfo[AGENT_INFO.recommendationCode] = this.props.agentReferralInfo[AGENT_INFO.recommendationCode];
        mygaSession.setAgentInfo(agentInfo);
        Analytics.setAgentReferralCode(agentInfo.referralCode);
        await saveApplication(APP_SECTION.referral);
      }
    }
    // 2022.05.11.ADivelbiss - need to reconcile parties at this point if the
    // user comes back to this page and make different selections.
    const parties = reconcileParties();
    if (parties) {
      mygaSession.setCurrentAppParties(parties);
      await saveApplication(APP_SECTION.parties);
      // 2022.05.19.ADivelbiss - currently assume all parties applied to all selected products.
      const nextProductDTOs = [...mygaSession.getCurrentAppProductDTOs()];
      nextProductDTOs.forEach(dto=>dto[MM_PRODUCT_DTO.parties]=parties);
      mygaSession.setCurrentAppProductDTOs(nextProductDTOs)
      await saveApplication(APP_SECTION.products);
    }
    
  };

  needAccount = () => {
    return mygaSession.getPrincipal() === null;
  };

  render() {
    return (
        <AppContentWrapper
            onNextPressed={this.onNextPressed}
            validateOnNext={this.validate}
            updatePage={this.props.updatePage}
            errorMessage={this.state.errorMessage}
            >
      
          <form className={'auth-form needs-validation'}
                ref={(form) => {
                  this.pageForm = form;
                }}>


            {/*{ this.needAccount() &&*/}
            
            
            {/*}*/}
  
            <div>
    
              {/*  email & username */}
              <Row className={'text-center'}>
                <div className={'col-8 offset-2 form-group'}>
                  <label className={''} htmlFor={'emailId'}>
                    Provide your email to begin:
                  </label>
                  <input id="emailId"
                         type="text"
                         className={'form-control'}
                         value={this.state.email}
                         pattern={regex.email}
                         onChange={e => {
                           this.setState({
                             email: e.target.value.trim(),
                             errorMessage:''
                           });
                         }}
                         required/>
                  <div className={"page-fine-print"}>
                    {MYGAStrings.Login_ClientEmailNote}
                  </div>
                </div>
    
              </Row>
    
              {/* Terms & Condition Acknowledgment */}
              <Row className={"pl-3"}>
                <Col xs={{offset: 0}} sm={{offset: 2}}>
                  <div className={'form-check'}>
                    <input id="input-tou-consent"
                           className={'form-check-input'}
                           type="checkbox"
                           checked={this.state.ackTermsOfUse}
                           required
                           onClick={(e) => {
                             this.setState({
                               ackTermsOfUse: e.target.checked,
                               errorMessage: '',
                               ackTermsOfUseErr: false
                             });
                           }}
                           onChange={() => {
                           }}
                    />
                    <label className={'form-check-label'} htmlFor={'input-tou-consent'}>I have read and agree to the <a
                        href={Resources.Urls.TermsOfUse} target="_blank" rel="noopener noreferrer">Terms and Conditions</a></label>
                  </div>
                </Col>
              </Row>
    
              {/* Privacy Policy Acknowledgment */}
              <Row className={"pl-3 pt-3"}>
                <Col xs={{offset: 0}} sm={{offset: 2}}>
                  <div className={'form-check'}>
                    <input id="input-pp-consent"
                           className={'form-check-input'}
                           type="checkbox"
                           required
                           checked={this.state.ackPrivacyPolicy}
                           onClick={(e) => {
                             this.setState({
                               ackPrivacyPolicy: e.target.checked,
                               errorMessage: '',
                               ackPrivacyPolicyErr: false
                             });
                           }}
                           onChange={() => {
                           }}
                    />
                    <label className={'form-check-label'} htmlFor={'input-pp-consent'}>I have read and agree to the <a
                        href={Resources.Urls.PrivacyPolicy} target="_blank" rel="noopener noreferrer">Privacy Policy</a></label>
                  </div>
                </Col>
              </Row>
    
              {/* State Selection */}
              {
                this.displayStateSelection && (
                    <>
                      <Row className="pl-3 pt-5">
                        <Col xs={{offset: 0, span: 12}} sm={{offset: 2, span: "auto"}} className={'page-section-title'}>
                        </Col>
                      </Row>
                      <Row className="pl-3 pt-2">
                        <Col xs={{offset: 0, span: 12}} sm={{offset: 2, span: "auto"}} className="question">
                          {Resources.Strings.Login_FloridaInformation}&nbsp;
                          <PopoverTooltip title={'Florida Residents'}
                                          content={Resources.Strings.Login_FloridaAcknowledgment}/>
                        </Col>
                        <Col className="answer">
                          <Row className="">
                            <Col >
                              <div className={'form-check form-check-inline'}>
                                <input type="radio"
                                       className="form-check-input"
                                       required
                                       id="input-state-fl-yes"
                                       name="input-state-fl"
                                       value="Yes"
                                       checked={this.state.appStateAbbr === 'FL'}
                                       onClick={(e) => {
                                         this.setState({
                                           appStateAbbr: 'FL'
                                         });
                                       }}
                                       onChange={() => {}}/>
                                <label className="form-check-label" htmlFor="input-state-fl-yes">Yes</label>
                              </div>
                            </Col>
                            <Col >
                              <div className='form-check form-check-inline '>
                                <input type="radio"
                                       className="form-check-input  "
                                       id="input-state-fl-no"
                                       name="input-state-fl"
                                       value="No"
                                       checked={this.state.appStateAbbr === ''}
                                       onClick={(e) => {
                                         this.setState({
                                           appStateAbbr: ''
                                         });
                                       }}
                                       onChange={() => {}}/>
                                <label className="form-check-label" htmlFor="input-state-fl-no">No</label>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </>
                )
              }
    
              {/* Available States List */}
              <Row className={"pl-xs-1 pl-sm-3  pt-3"}>
                <Col xs={{offset: 0, span: 12}} sm={{offset: 2}} className={''}>
                  {MYGAStrings.Login_MessageAvailableStates}<br/>
                   For CA or NY, please contact your agent or call <a href={'tel:1-800-420-5382'}>1-800-420-5382</a>.
                </Col>
              </Row>
  
            </div>
            
          </form>

        </AppContentWrapper>
    )
  }
  
}

export default GuestEmail;